import React from 'react';
import PageTitle from '../../../widgets/PageTitle/PageTitle';
import './YDCInformation.scss';
import { sanitizedHTML, parseSanitizedHTML } from '../../../utils/Helper';

const YDCInformation = (props) => {
  const { curLang, detail, information, title } = props;

  return (
    <>
      <PageTitle title={title} />
      <div style={{ backgroundColor: 'rgb(211, 211, 211)', padding: '20px' }}>
        {information?.information_description && (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizedHTML(information.information_description),
            }}
          ></div>
        )}
        <br />
        {detail?.date && (
          <div>
            {
              {
                sc: '日期',
                en: 'DATE',
                tc: '日期',
              }[curLang]
            }{' '}
            : {detail.date}
          </div>
        )}
        {detail?.time && (
          <div>
            {
              {
                sc: '时间',
                en: 'TIME',
                tc: '時間',
              }[curLang]
            }{' '}
            : {detail?.time}
          </div>
        )}
        {detail?.venue && (
          <div>
            {
              {
                sc: '地点',
                en: 'VENUE',
                tc: '地點',
              }[curLang]
            }{' '}
            : {detail?.venue}
          </div>
        )}
        <br />
        {information?.key_dates_description && (
          <>
            {
              {
                sc: '时间表',
                en: 'KEY DATE',
                tc: '時間表',
              }[curLang]
            }
            :
            <div
              className="key-dates-wrapper"
              dangerouslySetInnerHTML={{
                __html: sanitizedHTML(information?.key_dates_description),
              }}
            ></div>
          </>
        )}
        {information?.lucky_draw_result_description && (
          <div
            className="lucky-draw-wrapper"
            dangerouslySetInnerHTML={{
              __html: sanitizedHTML(information?.lucky_draw_result_description),
            }}
          />
        )}
      </div>
    </>
  );
};

export default YDCInformation;
